export default "__VITE_ASSET__BlhCvGPB__"